import { IApplicationState } from '../../types/redux';
import { isAvailableInRegions } from '../../selectors/regions';
import { MOSCOW_AND_REGION } from '../../constants/geo';
import { isAbUseExperimentGroup } from '../../utils/experiments';
import { NB_CONSULTANT_TRIGGERING_MESSAGE } from '../../constants/experiments';

export function motivationPopupAvailableSelector(state: IApplicationState) {
  return (
    isAbUseExperimentGroup(state.abUseExperiments, NB_CONSULTANT_TRIGGERING_MESSAGE, 'enabled') &&
    isAvailableInRegions(MOSCOW_AND_REGION)(state)
  );
}

export function motivationPopupOpenSelector(state: IApplicationState) {
  return state.newbuildingConsultant.showMotivationPopup;
}
